/* eslint-disable react/react-in-jsx-scope */
import { TabPanel, TabView } from 'primereact/tabview';
import { useState } from 'react';

import { CorrectiveActions } from '../../pages/correctiveActions/CorrectiveActions';
import { HcApprovers } from '../../pages/correctiveActions/HcApprovers';

export const AdminCA = () => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    return (
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel header="Templates">
                <CorrectiveActions />
            </TabPanel>

            <TabPanel header="HC Approvers">
                <HcApprovers />
            </TabPanel>
        </TabView>
    );
};
